import { ChartBinSize, ChartDataMode, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { IOTS_UPTIME_CHART_ENDPOINT } from '../iot-chart-endpoints';

export const IOTS_UPTIME_METRIC_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.IOTS_UPTIME_METRIC,
    chartType: ChartRendererType.METRIC,
    endpoint: IOTS_UPTIME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.DAY },
        { key: ChartQueryParam.DATA_MODE, value: ChartDataMode.PERCENTAGE }
    ]
};
